import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DropDownListDTO } from './../../../entity/dto/dropdownlist.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-make745-card-II',
  templateUrl: './make745-card-II.component.html'
})

export class Make745CardIIComponent extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;

  public listStatus?: DropDownListDTO[] = [];
  @Output() validDates = new EventEmitter();

  // tslint:disable-next-line: max-line-length
  constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
    super('Dados Conferência e Apontamento', false);

    this.formulario = this.formBuilder.group({
      responsavel_pela_conferencia_lote: [null, []],
      data_conferencia_fisica: [null, [Validators.pattern(this.regexDate)]],
      data_hora_apontamento: [null, [Validators.pattern(this.regexDate)]],
      status_processo: [null, []],
      observacao: [null, []],
      criado_por: [null, []],
    });

  }

  async ngOnInit(): Promise<void> {
    await Promise.all([this.getLists()]);
  }

  async getLists(): Promise<void> {
    await Promise.all([this.getListStatus()]);
    if (!this.formulario.get("status_processo").value)
      this.formulario.get("status_processo").setValue("Ensacado PA");
  }

  hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  async getListStatus(): Promise<void> {
    await this.formularioService
      .getListDropDownList('ensaque_cs_0745', 'status_processo')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listStatus = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorSafra
        );
      })
  }

  changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  validateDate(event): void {
    this.validDates.emit();
  }
}


